import { csvCell, csvReasonList } from './csvCell';
import type { FlaggedSuspendedRow } from './types';

const CSV_HEADERS = [
  'File',
  'First row',
  'Rows',
  'DIV',
  'BRANCH',
  'DC',
  'STOCK',
  'ITEM MASTER',
  'ITEM#',
  'DESCRIP',
  'Reasons',
  'WRH LOCATION',
  'OVERSTK WRH LOCATION',
  'QTY ON HAND',
  'STK Y/N',
  'ON-ORD QTY',
  'ALLOC QTY',
  'B/O QTY',
  'Open POs',
  'P/O#',
  'Open orders',
  'ORDER NUMBER',
] as const;

/**
 * Spreadsheet the team can paste into the action email they already send:
 * one line per item, with how many report rows it covered and every open
 * PO and order listed (space-separated) in one cell.
 */
export function flaggedRowsToCsv(rows: readonly FlaggedSuspendedRow[]): string {
  const lines = [CSV_HEADERS.join(',')];
  for (const row of rows) {
    lines.push(
      [
        row.fileName,
        String(row.sheetRow),
        String(row.rowCount),
        row.div,
        row.branch,
        row.dc,
        row.stockLocation,
        row.itemMasterLocation,
        row.itemNumber,
        row.description,
        csvReasonList(row.reasons),
        row.warehouseLocation,
        row.overstockWarehouseLocation,
        row.qtyOnHand,
        row.stockFlag,
        row.onOrderQty,
        row.allocQty,
        row.backorderQty,
        String(row.poNumbers.length),
        row.poNumbers.join(' '),
        String(row.orderNumbers.length),
        row.orderNumbers.join(' '),
      ]
        .map(csvCell)
        .join(','),
    );
  }
  return `${lines.join('\n')}\n`;
}
